import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import Defaultloadinggif from "../../../../layout/Others/Defaultloadinggif";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import AdminImageUploadZone from "../../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import { MdDelete, MdCancel } from "react-icons/md";

const Signup_avatars = () => {
    const { fetchRequest, globalImageUplaodAPI } = useMyContext();
    const baseURL = process.env.REACT_APP_Baseurl;
    const createApi = `${baseURL}/admin/signup_menu`;

    const [loading, setLoading] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const combinedRef = useRef([]);

    const [avatarList, setAvatarList] = useState([]);
    const [pendingFiles, setPendingFiles] = useState({});

    const [editUser, setEditUser] = useState({});

    // On Load
    useEffect(async () => {
        setLoading(true);
        await fetchRequest({
            method: 'GET',
            url: `${createApi}`,
            params: {},
            data: {},
        })
            .then((response) => {
                setEditUser(response?.signup_menu);
                let loadedAvatars = [];

                try {
                    // Try parsing JSON first
                    if (response?.signup_menu?.signup_avatars) {
                        // It might be a string or already an object depending on backend response format
                        const raw = response.signup_menu.signup_avatars;
                        loadedAvatars = typeof raw === 'string' ? JSON.parse(raw) : raw;
                    }
                } catch (e) {
                    console.error("Error parsing signup_avatars", e);
                }

                // Fallback for legacy data if new field is empty
                if ((!loadedAvatars || loadedAvatars.length === 0) && response?.signup_menu) {
                    const numberMap = [
                        "one", "two", "three", "four", "five",
                        "six", "seven", "eight", "nine", "ten"
                    ];
                    loadedAvatars = [];
                    numberMap.forEach((word, index) => {
                        const key = `signup_avatar_${word}`;
                        const val = response.signup_menu[key];
                        // Also check raw value? The response usually includes full URLs due to accessor, 
                        // but we might need the basename.
                        // For legacy display, the URL is fine.
                        if (val) {
                            loadedAvatars.push({
                                id: Date.now() + index,
                                avatar: val.split('/').pop(),
                            });
                        }
                    });
                }

                // Ensure IDs and structure
                if (Array.isArray(loadedAvatars)) {
                    loadedAvatars = loadedAvatars.map((item, idx) => ({
                        ...item,
                        id: item.id || Date.now() + idx,
                    }));
                } else {
                    loadedAvatars = [];
                }

                setAvatarList(loadedAvatars);
            }).catch((error) => {
                toast.error(error?.response?.data?.message || "Something went wrong ");
            }).finally(() => {
                setLoading(false);
            });
    }, [withOutRefresh]);

    const handleAddAvatar = () => {
        const newItem = {
            id: Date.now(),
            avatar: "",
        };
        setAvatarList([...avatarList, newItem]);
    };

    const handleDeleteAvatar = async (id, avatarFilename) => {
        if (!window.confirm("Are you sure you want to delete this avatar?")) return;
        if (pendingFiles[id]) {
            const newPending = { ...pendingFiles };
            delete newPending[id];
            setPendingFiles(newPending);
            setAvatarList(avatarList.filter(item => item.id !== id));
            return;
        }
        setAvatarList(avatarList.filter(item => item.id !== id));
        toast.info("Avatar removed from view. (Note: Deletion might not persist without Store API)");
    };

    const handleAvatarFileChange = (event, itemId) => {
        const { files } = event.target;
        if (files?.length > 0) {
            const newFile = files[0];
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
            if (!allowedTypes.includes(newFile?.type)) {
                toast.error("Only JPG, JPEG, and PNG files are allowed.");
                return;
            }
            setPendingFiles(prev => ({
                ...prev,
                [itemId]: newFile
            }));
            const previewUrl = URL.createObjectURL(newFile);
            setAvatarList(prev => prev.map(item => item.id === itemId ? { ...item, avatar: previewUrl } : item));
        }
    };

    const handleClearPendingFile = (itemId) => {
        setPendingFiles(prev => {
            const newState = { ...prev };
            delete newState[itemId];
            return newState;
        });
        setAvatarList(prev => prev.map(item => item.id === itemId ? { ...item, avatar: "" } : item));
    };

    const setRef = (element, id) => {
        if (element) {
            combinedRef.current[id] = element;
        }
    };

    const handleSave = async () => {
        const pendingIds = Object.keys(pendingFiles);

        setShowOverlay(true);
        try {
            if (pendingIds.length > 0) {
                const formData = new FormData();
                formData.append('id', editUser.id);
                formData.append('modelName', "SignupMenu");

                pendingIds.forEach(id => {
                    const fieldName = `avatar_${id}`;
                    formData.append(fieldName, pendingFiles[id]);
                    formData.append('imageFields[]', fieldName);
                });

                const response = await fetchRequest({
                    method: 'POST',
                    url: globalImageUplaodAPI(),
                    data: formData,
                });

                if (!response?.status && !response?.data?.status) {
                    throw new Error(response?.data?.message || "Upload failed");
                }

                toast.success("Avatars uploaded successfully");
                setPendingFiles({});
                setWithOutRefresh(!withOutRefresh);
            }
        } catch (err) {
            console.error(err);
            toast.error(err?.message || "Something went wrong during save");
        } finally {
            setShowOverlay(false);
        }
    };

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />;
    }

    return (
        <>
            {showOverlay && (<Response_Processing />)}
            <AdminSaveHeader heading={"Upload Signup Avatars"} saveText={"Save Avatars"} saveMethod={handleSave} loading={showOverlay} />

            <FormContainer>
                <Wrapper className="w-100">
                    <MessageHeading text="Signup Avatars" />
                    <div className="row">
                        {avatarList.map((item, index) => {
                            const isPending = !!pendingFiles[item.id];

                            return (
                                <div key={item.id} className="col-md-4 col-sm-6 mb-4">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <div className="d-flex align-items-center gap-2"><MessageLabel text={`Avatar ${index + 1}`} /></div>
                                        <MdDelete size={18} className="text-danger cursor-pointer" title="Delete Avatar" onClick={() => handleDeleteAvatar(item.id, item.avatar)} />
                                    </div>
                                    <AdminImageUploadZone onChange={(e) => handleAvatarFileChange(e, item.id)} selectedFile={pendingFiles[item.id]} uploadedImage={item.avatar} onDelete={() => isPending ? handleClearPendingFile(item.id) : (() => { })} fileInputRef={setRef} name={`avatar-${item.id}`} id={editUser?.id} idAttribute={`signup-avatar-${item.id}`} ref={(el) => (combinedRef.current[item.id] = el)} />
                                </div>
                            );
                        })}
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button type="button" className="btn btn-outline-primary" onClick={handleAddAvatar}>+ Add Avatar</button>
                        <span className="text-muted">Total: {avatarList.length}</span>
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <AdminCustomButton id="signup-avatar-save" className="px-3 py-1 m-0" saveMethod={handleSave} saveText="Save Avatars" />
                    </div>
                </Wrapper>
            </FormContainer>
        </>
    );
};

export default Signup_avatars;